var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-err404"},[_c('div',{staticClass:"err404-title"},[_vm._v(" 您访问的页面找不到，请输入正确的地址~ ")])])}]

export { render, staticRenderFns }